import { useSelector } from 'react-redux';

import type { FreightConfiguration } from '@shipstation/client-common/types/fulfillment-plan';

import { FulfillmentPlanFulfillmentType } from '../../../enums/fulfillment-plan-fulfillment-type';
import Global from '../../../store/global-selectors';

type FreightShipmentPropertySelector = (
  state: unknown,
  props: { fulfillmentPlanId: string | undefined; property: string },
) => FreightConfiguration | undefined;

export const useFreightConfiguration = (fulfillmentPlanId: string | undefined) => {
  const fulfillmentType = useSelector((state) => Global.selectEntitiesFulfillmentPlanFulfillmentType(state, { fulfillmentPlanId }));
  const isFreightLtl = fulfillmentType === FulfillmentPlanFulfillmentType.FreightLtl;

  const freightConfiguration = useSelector((state) =>
    isFreightLtl
      ? (Global.selectEntitiesFulfillmentPlanProperty as FreightShipmentPropertySelector)(state, {
          fulfillmentPlanId,
          property: 'freightConfiguration',
        })
      : undefined,
  );

  return { isFreightLtl, freightConfiguration };
};
